import { NgModule } from '@angular/core';
import { LayoutComponent } from 'app/core/layout/layout.component';
import { CenteredLayoutModule } from 'app/core/layout/layouts/horizontal/centered/centered.module';
import { EnterpriseLayoutModule } from 'app/core/layout/layouts/horizontal/enterprise/enterprise.module';
import { MaterialLayoutModule } from 'app/core/layout/layouts/horizontal/material/material.module';
import { ModernLayoutModule } from 'app/core/layout/layouts/horizontal/modern/modern.module';
import { ClassicLayoutModule } from 'app/core/layout/layouts/vertical/classic/classic.module';
import { ClassyLayoutModule } from 'app/core/layout/layouts/vertical/classy/classy.module';
import { CompactLayoutModule } from 'app/core/layout/layouts/vertical/compact/compact.module';
import { DenseLayoutModule } from 'app/core/layout/layouts/vertical/dense/dense.module';
import { FuturisticLayoutModule } from 'app/core/layout/layouts/vertical/futuristic/futuristic.module';
import { ThinLayoutModule } from 'app/core/layout/layouts/vertical/thin/thin.module';
import { SettingsModule } from 'app/core/layout/common/settings/settings.module';
import { SharedModule } from 'app/shared/shared.module';
import { EmptyLayoutModule } from 'app/core/layout/layouts/empty/empty.module';

const layoutModules = [
    // Empty
    EmptyLayoutModule,

    // Horizontal navigation
    CenteredLayoutModule,
    EnterpriseLayoutModule,
    MaterialLayoutModule,
    ModernLayoutModule,

    // Vertical navigation
    ClassicLayoutModule,
    ClassyLayoutModule,
    CompactLayoutModule,
    DenseLayoutModule,
    FuturisticLayoutModule,
    ThinLayoutModule
];

@NgModule({
    declarations: [
        LayoutComponent
    ],
    imports     : [
        SharedModule,
        SettingsModule,
        ...layoutModules
    ],
    exports     : [
        LayoutComponent,
        ...layoutModules
    ]
})
export class LayoutModule
{
}
